import Vue from 'vue'
import Vuex from 'vuex'
import word from "@/store/word";
import user from "@/store/user";
import pdf  from "@/store/pdf";
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {
  },
  actions: {

  },
  modules: {
    word,
    user,
    pdf
  },
  plugins:[
    createPersistedState({
      storage:window.sessionStorage,
      key:"store"
    })
  ]
})
